import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Router } from '@angular/router';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {debounceTime} from 'rxjs/operators';
import  { GridOptions }  from  "ag-grid/main";

import {
  APP_DATE_FORMAT,
  CommonUtility,
  DataService,
  DateUtility, EDIT_BTN,
  MIN_CHAR_SEARCH_LENGTH,
  ServerConstantsService, SINGLE_ROW_HEADER,
  AgGridUtility
} from '../shared/index';
import {ModalDismissReasons, NgbDateStruct, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from 'angular2-notifications';
import {Subject} from "rxjs/Subject";
import {ReferenceTableService} from "../reference-table.service";
import {ProviderService} from "../provider-management/provider-management.service";


@Component({
  selector: 'application-configuration',
  templateUrl: './applicationConfiguration.component.html',
  styleUrls: ['./applicationConfiguration.component.scss']
})
export class ApplicationConfigurationComponent implements OnInit {

  private _danger = new Subject<string>();
  errorMessage: string;
  private _success = new Subject<string>();
  successMessage: string;
  ServerConstants: any;
  userActionNotificationsMap: any;

  dropdownEntityName: string;
  functionalEntityName: string;
  staticDataMap: StaticData[];
  isAddNewEntity: Boolean = false;
  newEntityName: string;
  newEntityType: string;
  isEntitySelected: Boolean = false;
  selectedEntityName: string;
  selectedEntityType: string;
  currentStaticData: StaticData;
  oldStaticData: StaticData;
  valArray: any[];
  //currentIndex: number;
  serverObj: any;
  isNewRow: Boolean = false;
  entityTypes = [{name: 'Dropdown', value: 'DD'}, {name: 'Functional', value: 'FN'}, {name: 'Navigation', value: 'NV'}, {name: 'Reference Table', value: 'RT'} ];
  dialogTitle = 'Edit configuration';
  isActive: Boolean = false;
  isDialogOpen: Boolean = false;
  isAlertRequired: Boolean = true;
  noData: Boolean = false;

  // Elastic Search variables
  currentSearch: string;
  elasticSuggestions = new BehaviorSubject<any>(null);
  suggestions: any = [];
  results: any = [];
  APP_DATE_FORMAT = APP_DATE_FORMAT;
  refData: any;

  modalReference: any;
  closeResult: string;
  todayDate: NgbDateStruct;
  today: Date;

  /*Grid Table*/
  gridOptions;
  columnDefs: any;
  tabToNextCell:any;
  context: any;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;

  @ViewChild('content') public contentElement: ElementRef;
  @ViewChild('header') header: ElementRef;
  @ViewChild('headerTextPopUp') headerTextPopUp: ElementRef;
  @ViewChild('save') save: ElementRef;

  gridApi: any;
  firstTime: Boolean = true;

  constructor(
    private router: Router,
    private http: HttpClient,
    private modalService: NgbModal,
    private dateUtil: DateUtility,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    public dataService:DataService,
    public providerService:ProviderService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions  =  <GridOptions>{};

  }

  ngOnInit() {

    /* error message */
    this.http.get<any>(this.ServerConstants.SERVER_API_URL + '/userinfo').subscribe(
      data => {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            console.log('role : ' + data.roles[0].id);
            if(data.roles[0].id === 5){
                this.router.navigate(['dashboard']);
              } 
            }
          }
    this._danger.subscribe((message) => this.errorMessage = message);
    this._danger.pipe(
      debounceTime(5000)
    ).subscribe(() => this.errorMessage = null);

    /* Success message*/
    this._success.subscribe((message) => this.successMessage = message);
    this._success.pipe(
      debounceTime(5000)
    ).subscribe(() => this.successMessage = null);

    /* Read reference table data */
    this.getRefData();
    this.validDate();
    this.getColumnDefinitions();
  

}, response => {
console.log('error', response);
if(response.status === 401){
this.router.navigate(['dashboard']);
}
}, () => {

});
  }

  validDate(){
    this.today = new Date();

    this.todayDate = {
      month: this.today.getMonth()+1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };
  }

  getRefData() {
    this.data.currentMessage.subscribe(
      (message) => {
        this.refData = message;
        this.parseRefTableData(message);
      });
  }

  parseRefTableData(myData) {
    if (myData !== undefined && myData.englishDropDown) {
      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
    }
  }

  saveConfiguration() {
    if (this.isNewRow) {
      const newObj = Object.assign({}, this.currentStaticData);
      if (this.isActive) {
        newObj.activeSW = 'Y';
      } else {
        newObj.activeSW = 'N';
        newObj.activeBeginDt = null;
        newObj.activeEndDt = null;
      }
      if (newObj.activeBeginDt != null) {
        newObj.activeBeginDt = this.dateUtil.convertDateForServer(newObj.activeBeginDt);
      }
      if (newObj.activeEndDt != null) {
        newObj.activeEndDt = this.dateUtil.convertDateForServer(newObj.activeEndDt);
      }
      let isCodeSame = false;
      this.staticDataMap.forEach((item) => {
        if (item.value === newObj.value) isCodeSame = true;
      });
      if (isCodeSame) {
        this.notificationService.error('Admin', 'The input code exist already, please try EDIT option.');
      } else {
        this.staticDataMap.push(newObj);
        this.updateStaticData();
      }
    } else if (this.currentStaticData !== undefined) {
      const modifiedObj = Object.assign({}, this.currentStaticData);
      if (modifiedObj.activeBeginDt != null) {
        modifiedObj.activeBeginDt = this.dateUtil.convertDateForServer(modifiedObj.activeBeginDt);
      }
      if (modifiedObj.activeEndDt != null) {
        modifiedObj.activeEndDt = this.dateUtil.convertDateForServer(modifiedObj.activeEndDt);
      }
      if (this.isActive) {
        modifiedObj.activeSW = 'Y';
      } else {
        modifiedObj.activeSW = 'N';
        modifiedObj.activeBeginDt = null;
        modifiedObj.activeEndDt = null;
      }
      if (modifiedObj.name === this.oldStaticData.name && modifiedObj.value === this.oldStaticData.value
        && modifiedObj.activeSW === this.oldStaticData.activeSW && modifiedObj.activeBeginDt === this.oldStaticData.activeBeginDt
        && modifiedObj.activeEndDt === this.oldStaticData.activeEndDt) {
        this.notificationService.error('Admin', 'There is no change in the data.');
      } else {
        this.staticDataMap[modifiedObj.index] = modifiedObj;
        this.updateStaticData();
      }
    }
    this.isAlertRequired = false;
    this.closeDialog();

  }

  restrictSpecial(event){
    if((/[<>{}]/.test(event.key))){
      event.returnValue = false;
      return;
     }
      event.returnValue = true;
  }
  
  deleteConfiguration(deleteIndex) {
    const doc = this.staticDataMap[deleteIndex];
    this.staticDataMap.forEach((item, index) => {
      if (item === doc) this.staticDataMap.splice(index, 1);
    });
    this.updateStaticData();
  }


  updateStaticData() {
    this.serverObj.dataValue.EN = this.staticDataMap;
    if(this.serverObj.name === "NOREFPROVIDERS"){
      let token = this.dataService.getSharedDataObject().get("token");
      this.providerService.getAllProvidersList(token).subscribe((data)=>{
        data.forEach((element)=>{
          this.serverObj.dataValue.EN.forEach((subelement)=>{
            if(element.providerName == subelement.name){
              subelement.id = element.id.toString();
            }
          })
        })
        this.serverObj.dataValue.EN.forEach((subelement)=>{
          if(subelement.id === undefined){
            subelement.id = "0";
          }
        })
        setTimeout(()=>{
          this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/staticData/save', this.serverObj).subscribe(
            (val) => {
              // Add "Pick an Option" to all reference tables
              this.serverObj = val;
              this.staticDataMap = val.dataValue.EN;
            },
            response => {
              this.notificationService.error('Admin', this.userActionNotificationsMap.ERROR);
            },
            () => {
              this.notificationService.success('Admin', this.userActionNotificationsMap.UPDATE);
            });
        },0);
    })
    }
    else{
      this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/staticData/save', this.serverObj).subscribe(
        (val) => {
          // Add "Pick an Option" to all reference tables
          this.serverObj = val;
          this.staticDataMap = val.dataValue.EN;
        },
        response => {
          this.notificationService.error('Admin', this.userActionNotificationsMap.ERROR);
        },
        () => {
          this.notificationService.success('Admin', this.userActionNotificationsMap.UPDATE);
        });
    }
  }


  openDialog(content, data, index) {
    this.dialogTitle = 'Edit configuration';
    this.isNewRow = false;
    this.isDialogOpen = true;
    //this.currentIndex = index;
    this.currentStaticData = Object.assign({}, data);
    if (this.currentStaticData.activeSW === 'Y') {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
    if (this.currentStaticData.activeBeginDt !== undefined && this.currentStaticData.activeBeginDt !== null) {
      this.currentStaticData.activeBeginDt = this.dateUtil.convertDateFromServer(this.currentStaticData.activeBeginDt);
    }
    if (this.currentStaticData.activeEndDt !== undefined && this.currentStaticData.activeEndDt !== null) {
      this.currentStaticData.activeEndDt = this.dateUtil.convertDateFromServer(this.currentStaticData.activeEndDt);
    }
    this.oldStaticData = Object.assign({}, data);
    this.modalReference = this.modalService.open(content, {centered: true, size: 'lg'});
    this.modalReference.result.then((result) => {
      this.isDialogOpen = false;
      this.successMessage = null;
      this.errorMessage = null;
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.isDialogOpen = false;
      this.successMessage = null;
      this.errorMessage = null;
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  openNewDialog(content) {
    this.dialogTitle = 'Add configuration';
    this.isNewRow = true;
    this.isDialogOpen = true;
    this.isActive = false;
    this.currentStaticData = new StaticData();
    this.modalReference = this.modalService.open(content, {centered: true, size: 'lg'});
    this.modalReference.result.then((result) => {
      this.isDialogOpen = false;
      this.successMessage = null;
      this.errorMessage = null;
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.isDialogOpen = false;
      this.successMessage = null;
      this.errorMessage = null;
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  closeDialog() {
    if (this.isAlertRequired && !this.isNewRow) {
      this.isAlertRequired = false;
      if (this.currentStaticData !== undefined) {
        const modifiedObj = Object.assign({}, this.currentStaticData);
        if (modifiedObj.activeBeginDt != null) {
          modifiedObj.activeBeginDt = this.dateUtil.convertDateForServer(modifiedObj.activeBeginDt);
        }
        if (modifiedObj.activeEndDt != null) {
          modifiedObj.activeEndDt = this.dateUtil.convertDateForServer(modifiedObj.activeEndDt);
        }
        if (this.isActive) {
          modifiedObj.activeSW = 'Y';
        } else {
          modifiedObj.activeSW = 'N';
          modifiedObj.activeBeginDt = null;
          modifiedObj.activeEndDt = null;
        }
        if (modifiedObj.name === this.oldStaticData.name && modifiedObj.value === this.oldStaticData.value
          && modifiedObj.activeSW === this.oldStaticData.activeSW && modifiedObj.activeBeginDt === this.oldStaticData.activeBeginDt) {
          this.isAlertRequired = true;
          this.isDialogOpen = false;
          this.successMessage = null;
          this.errorMessage = null;
          this.modalReference.close();
        } else {
          this._danger.next('Data was modified, Do you want to close without saving? If yes click CLOSE button now.');
          //  this.notificationService.error('Admin', 'Data was modified, Do you want to close without saving? If yes click CLOSE button now.');
        }
      }
    } else {
      this.isAlertRequired = true;
      this.isDialogOpen = false;
      this.successMessage = null;
      this.errorMessage = null;
      this.modalReference.close();
    }
  }

  /* get static data */
  load(selectedEntityName) {
    let entityType = '';
    this.entityTypes.forEach(element => {
      if(element.name === this.selectedEntityType)
      {
        entityType = element.value;
      }

    });

    this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/staticData/find/', {
      name: selectedEntityName,
      type: entityType
    }).subscribe((val) => {
        // Add "Pick an Option" to all reference tables
        this.serverObj = val;
        if (val.dataValue !== undefined && val.dataValue.EN !== undefined) {
          val.dataValue.EN.forEach((value)=>{
            if(value.activeBeginDt!==null && value.activeBeginDt!==undefined){
              value.activeBeginDt = this.dateUtil.formatDate(value.activeBeginDt);
            }
            if(value.activeEndDt!==null && value.activeEndDt!==undefined){
              value.activeEndDt = this.dateUtil.formatDate(value.activeEndDt);
            }
          })
          this.staticDataMap = val.dataValue.EN;

          let index = 0;
          this.staticDataMap.forEach((item) => {
            item.index = index;
            index++;
          });
        }
      },
      response => {
        this.notificationService.error('Admin', this.userActionNotificationsMap.ERROR);
      },
      () => {

      });
  }

  elasticSearch(searchQuery, results) {
    this.http.post(this.ServerConstants.SERVER_API_URL + '/static/name/', {text: searchQuery}).subscribe(
      (val: any[]) => {
        this.valArray = val;
        if (this.valArray === null || this.valArray === undefined || this.valArray.length === 0) {
          this.noData = true;
        }
        results.next(val);
      },
      response => {
        this.notificationService.error('Admin', this.userActionNotificationsMap.ERROR);
        results.next(null);
      }
    );
  }

  getSuggestions(event) {
    if (this.currentSearch.length < MIN_CHAR_SEARCH_LENGTH) {
      this.noData = false;
    }
    if (this.currentSearch.length >= MIN_CHAR_SEARCH_LENGTH) {
      event.srcElement.blur();
      event.preventDefault();
      this.elasticSearch(this.currentSearch, this.elasticSuggestions);
      this.elasticSuggestions.subscribe((value) => {
        this.suggestions = value;
      });
    } else {
      this.suggestions = [];
    }
  }

  autoCompleteResultClick(result) {
    this.currentSearch = result.name;
    this.isEntitySelected = true;
    this.selectedEntityName = this.currentSearch;
    this.results = [];
    for (const results of this.suggestions) {
      if (result.id === results.id) {
        this.results.push(Object.assign({}, results));
        this.entityTypes.forEach(element => {
          if(element.value === results.dataType)
          {
            this.selectedEntityType = element.name;
          }
        });

        this.load(this.selectedEntityName);
      }
    }
    this.suggestions = [];
    this.elasticSuggestions.next(null);
  }



  onGridReady(params) {
    this.gridApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  getColumnDefinitions() {
    this.columnDefs = [
      { headerName: 'Code',
        field: 'value',
        width: 120,
      },
      {
        headerName: 'Description',
        field: "name",
        cellStyle: {'white-space': 'normal'},
      },
      {
        headerName: 'Is active',
        field: "activeSW",
        cellStyle: {'white-space': 'normal'},
        width: 100,
      },
      {
        headerName: 'Active begin date',
        field: 'activeBeginDt',
        cellStyle: {'white-space': 'normal'},
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.filterDates,
        }
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        cellStyle: {'text-align': 'center !important'},
        width: 120,
        suppressFilter: true,
        suppressSorting: true,
      },
    ];

    this.context = {
      component: this,
    };

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  getEditButton(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    const image = EDIT_BTN;
    element.innerHTML = image;

    element.addEventListener('click', () => {
      that.openDialog(that.contentElement, params.data);
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32){
        that.openDialog(that.contentElement, params.data);
      }
    });
    element.setAttribute("tabindex", "0");
    return element;
  }

  filterDates(filterLocalDateAtMidnight, cellValue) {
    if (!cellValue) {
      return;
    }
    const dateParts = cellValue.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  focusHeaderPopUp(e: KeyboardEvent) {
    if (!e.shiftKey && e.keyCode === 9) {
      e.preventDefault();
      setTimeout(() => this.headerTextPopUp.nativeElement.focus(), 0);
      this.headerTextPopUp.nativeElement.click();
    }
  }

  focusSave(e: KeyboardEvent) {
    if (e.keyCode === 9  && e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.save.nativeElement.focus(), 0);
      this.save.nativeElement.click();
    }
  }

  focusSummary(e) {
    this.firstTime = false;
    this.addEventListenerToButton(e);
  }

  addEventListenerToButton(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }
    if(this.staticDataMap.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  onPaginationChanged() {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }
}

export class StaticData {
  constructor(
    public name?: string,
    public value?: string,
    public activeSW?: string,
    public activeBeginDt?: any,
    public activeEndDt?:any,
    public index?: number,
    public id?:number
  ) {
  }
}

export class WpStaticData {
  constructor(
    public name?: string,
    public dataType?: string,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/application-configuration/applicationConfiguration.component.ts